/**
 * Terminal Toggle Button
 *
 * Allows users to switch between traditional portfolio and terminal explorer mode
 */

import { useState } from 'react'

interface TerminalToggleProps {
  isTerminalMode: boolean
  onToggle: () => void
}

export function TerminalToggle({ isTerminalMode, onToggle }: TerminalToggleProps) {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <button
      onClick={onToggle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      title={isTerminalMode ? 'Switch to GUI Mode' : 'Switch to Terminal Mode'}
      style={{
        position: 'fixed',
        top: '1rem',
        right: '1rem',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        padding: '0.5rem 1rem',
        backgroundColor: isTerminalMode
          ? 'rgba(255, 255, 255, 0.1)'
          : 'rgba(0, 0, 0, 0.8)',
        border: isTerminalMode
          ? '1px solid #ffffff'
          : '1px solid #00ff41',
        borderRadius: '0.25rem',
        color: isTerminalMode ? '#ffffff' : '#00ff41',
        fontFamily: '"JetBrains Mono", "Fira Code", monospace',
        fontSize: '0.875rem',
        fontWeight: 500,
        cursor: 'pointer',
        backdropFilter: 'blur(10px)',
        transition: 'all 0.2s ease',
        transform: isHovered ? 'translateY(-2px)' : 'translateY(0)',
        boxShadow: isHovered
          ? isTerminalMode
            ? '0 4px 12px rgba(255, 255, 255, 0.2)'
            : '0 4px 12px rgba(0, 255, 65, 0.3)'
          : 'none',
        outline: 'none',
      }}
      onFocus={(e) => {
        e.currentTarget.style.outline = '2px solid ' + (isTerminalMode ? '#ffffff' : '#00ff41')
        e.currentTarget.style.outlineOffset = '2px'
      }}
      onBlur={(e) => {
        e.currentTarget.style.outline = 'none'
      }}
    >
      <span style={{ fontSize: '1.2rem' }}>
        {isTerminalMode ? '🖥️' : '⌨️'}
      </span>
      <span>{isTerminalMode ? 'GUI Mode' : 'Terminal Mode'}</span>
    </button>
  )
}
